/**
 * FencerFuel Theme JavaScript
 * Cart drawer, quiz, sticky ATC, FAQ, analytics placeholders
 */

(function () {
  'use strict';

  /* Force the official logo even when Shopify serves a stale cached homepage. */
  const cleanLogoSrc = '//fnmyzy-us.myshopify.com/cdn/shop/t/2/assets/ff-logo-clean-20260704-1936.png';
  function forceCleanLogo() {
    document.querySelectorAll('.ff-brand-logo__image').forEach(img => {
      img.src = cleanLogoSrc;
      img.removeAttribute('srcset');
      img.width = 1024;
      img.height = 382;
      img.style.width = 'min(320px, 62vw)';
      img.style.height = 'auto';
      img.style.maxHeight = '94px';
      img.style.objectFit = 'contain';
      img.style.opacity = '1';
    });
  }
  forceCleanLogo();
  document.addEventListener('DOMContentLoaded', forceCleanLogo);

  /* ── Mobile nav ── */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ── Cart drawer ── */
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    cartOverlay?.classList.add('is-open');
    cartDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartOverlay?.classList.remove('is-open');
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartCloseBtns.forEach(btn => btn.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);

  /* ── Cart upsells ── */
  document.querySelectorAll('[data-upsell-add]').forEach(btn => {
    btn.addEventListener('click', function () {
      const handle = this.dataset.productHandle;
      if (handle && window.Shopify?.addItem) {
        window.Shopify.addItem(handle, 1);
      } else {
        this.textContent = 'Added!';
        this.disabled = true;
      }
    });
  });

  /* ── Subscribe toggle ── */
  document.querySelectorAll('[data-subscribe-toggle]').forEach(toggle => {
    const options = toggle.querySelectorAll('[data-purchase-type]');
    options.forEach(opt => {
      opt.addEventListener('click', () => {
        options.forEach(o => o.classList.remove('is-active'));
        opt.classList.add('is-active');
        const priceEl = document.querySelector('[data-product-price]');
        const newPrice = opt.dataset.price;
        if (priceEl && newPrice) priceEl.textContent = newPrice;
      });
    });
  });

  /* ── Sticky ATC ── */
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const productForm = document.querySelector('[data-product-form]');
  if (stickyAtc && productForm) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        stickyAtc.classList.remove('is-visible');
        document.body.classList.remove('has-sticky-atc');
      } else {
        stickyAtc.classList.add('is-visible');
        document.body.classList.add('has-sticky-atc');
      }
    }, { threshold: 0 });
    observer.observe(productForm);
  }

  /* ── FAQ accordion ── */
  document.querySelectorAll('[data-faq-question]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-faq-item]');
      const wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('[data-faq-item]').forEach(i => i.classList.remove('is-open'));
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  /* ── Quiz ── */
  const quiz = document.querySelector('[data-quiz]');
  if (quiz) {
    const steps = quiz.querySelectorAll('[data-quiz-step]');
    const progressBar = quiz.querySelector('[data-quiz-progress]');
    const backBtn = quiz.querySelector('[data-quiz-back]');
    const nextBtn = quiz.querySelector('[data-quiz-next]');
    let currentStep = 0;
    const answers = {};

    const plans = {
      'kids-starter': {
        name: 'Kids Starter',
        description: 'Perfect for young fencers just beginning their nutrition routine. Includes Daily Fencer Gummies delivered monthly.',
        products: ['kids-daily-fencer-gummies'],
        url: '/products/kids-starter-subscription'
      },
      'kids-training': {
        name: 'Kids Training',
        description: 'For active young fencers training 3+ days per week. Daily + Hydration gummies for complete routine support.',
        products: ['kids-daily-fencer-gummies', 'kids-strip-hydration-gummies'],
        url: '/products/kids-training-subscription'
      },
      'kids-competition': {
        name: 'Kids Competition',
        description: 'Full competition-ready routine with Daily, Hydration, Focus, and Travel & Defense gummies.',
        products: ['kids-daily-fencer-gummies', 'kids-strip-hydration-gummies', 'kids-strong-legs-gummies', 'kids-travel-defense-gummies'],
        url: '/products/kids-competition-subscription'
      },
      'adult-training': {
        name: 'Adult Training',
        description: 'Premium daily nutrition routine for competitive fencers and coaches. Daily Performance + Hydration gummies.',
        products: ['adult-daily-performance-gummies', 'adult-hydration-gummies'],
        url: '/products/adult-training-subscription'
      }
    };

    function updateProgress() {
      const pct = ((currentStep + 1) / steps.length) * 100;
      if (progressBar) progressBar.style.width = pct + '%';
    }

    function showStep(n) {
      steps.forEach((s, i) => s.classList.toggle('is-active', i === n));
      if (backBtn) backBtn.style.visibility = n === 0 ? 'hidden' : 'visible';
      if (nextBtn) {
        nextBtn.textContent = n === steps.length - 2 ? 'See Results' : 'Next';
        nextBtn.style.display = n === steps.length - 1 ? 'none' : 'inline-flex';
      }
      updateProgress();
    }

    quiz.querySelectorAll('[data-quiz-option]').forEach(opt => {
      opt.addEventListener('click', function () {
        const step = this.closest('[data-quiz-step]');
        step.querySelectorAll('[data-quiz-option]').forEach(o => o.classList.remove('is-selected'));
        this.classList.add('is-selected');
        const key = step.dataset.questionKey;
        answers[key] = this.dataset.value;
      });
    });

    function calculateResult() {
      const age = answers.age;
      const frequency = answers.frequency;
      const goal = answers.goal;

      if (age === 'adult' || age === 'coach') return plans['adult-training'];
      if (frequency === 'competition' || goal === 'competition') return plans['kids-competition'];
      if (frequency === 'regular' || frequency === 'daily') return plans['kids-training'];
      return plans['kids-starter'];
    }

    function showResult() {
      const plan = calculateResult();
      const resultStep = quiz.querySelector('[data-quiz-result]');
      if (resultStep) {
        resultStep.querySelector('[data-result-name]').textContent = plan.name;
        resultStep.querySelector('[data-result-desc]').textContent = plan.description;
        const cta = resultStep.querySelector('[data-result-cta]');
        if (cta) cta.href = plan.url;
        resultStep.classList.add('is-active');
        steps.forEach(s => { if (!s.hasAttribute('data-quiz-result')) s.classList.remove('is-active'); });
        currentStep = steps.length - 1;
        updateProgress();
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const step = steps[currentStep];
        const key = step.dataset.questionKey;
        if (!answers[key]) {
          alert('Please select an option to continue.');
          return;
        }
        if (currentStep === steps.length - 2) {
          showResult();
        } else {
          currentStep++;
          showStep(currentStep);
        }
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (currentStep > 0) {
          currentStep--;
          showStep(currentStep);
        }
      });
    }

    showStep(0);
  }

  /* ── Newsletter ── */
  document.querySelectorAll('[data-newsletter-form]').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      if (window._learnq) {
        window._learnq.push(['identify', { $email: email }]);
        window._learnq.push(['track', 'Newsletter Signup']);
      }
      const msg = this.querySelector('[data-newsletter-msg]');
      if (msg) {
        msg.textContent = 'Thanks! Check your inbox for 10% off your first routine.';
        msg.style.display = 'block';
      }
      this.querySelector('input[type="email"]').value = '';
    });
  });

  /* ── Analytics placeholders ── */
  window.FencerFuel = window.FencerFuel || {};
  window.FencerFuel.track = function (event, data) {
    if (typeof gtag === 'function') gtag('event', event, data);
    if (typeof fbq === 'function') fbq('trackCustom', event, data);
    if (window._learnq) window._learnq.push(['track', event, data]);
  };

  document.querySelectorAll('[data-track]').forEach(el => {
    el.addEventListener('click', () => {
      window.FencerFuel.track(el.dataset.track, { label: el.textContent.trim() });
    });
  });
})();
